var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M754.7 272H259.3c-20.6 0-37.3 16.5-37.3 36.8v406.4c0 20.3 16.7 36.8 37.3 36.8h278.9c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8H268.7c-10.3 0-18.7-8.2-18.7-18.4V592h152c44.2 0 80-35.8 80-80s-35.8-80-80-80H250V318c0-10.2 8.4-18.4 18.7-18.4h476.7c10.3 0 18.7 8.2 18.7 18.4v180.2c0 7.6 6.2 13.8 13.8 13.8h0.4c7.6 0 13.8-6.2 13.8-13.8V308.8c-0.1-20.3-16.8-36.8-37.4-36.8zM252 462h150c27.6 0 50 22.4 50 50s-22.4 50-50 50H252V462z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M407 512m-15 0a15 15 0 1 0 30 0 15 15 0 1 0-30 0Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M837.6 647.4c-0.1-0.1-0.3-0.2-0.4-0.3-0.1-0.1-0.2-0.2-0.3-0.4l-69-69c-5.9-5.9-15.4-5.9-21.2 0-5.9 5.9-5.9 15.4 0 21.2l43.8 43.8H616c-8.3 0-15 6.7-15 15s6.7 15 15 15h175.1l-43.7 43.7c-5.9 5.9-5.9 15.4 0 21.2 5.9 5.9 15.4 5.9 21.2 0l69-69c5.9-5.8 5.9-15.3 0-21.2z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.2a753531c8d5746d09ae500f3562c03d.svg";
export { ForwardRef as ReactComponent };